import React from 'react';
import { Link } from 'react-router-dom';

import isInternalLink from '@dashboard/services/isInternalLink';
import { Button } from './ui/button';

function EmptyState({ children }) {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center justify-center gap-1 px-6 py-12 text-center">
      {children}
    </div>
  );
}

function Icon({ icon: Icon }) {
  return (
    <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
      <Icon className="h-5 w-5" aria-hidden="true" />
    </div>
  );
}

function Title({ children }) {
  return <h3 className="text-sm font-medium text-foreground">{children}</h3>;
}

function Subtitle({ children }) {
  return <p className="text-sm text-muted-foreground">{children}</p>;
}

function Action({ children, to, href, onClick, ...rest }) {
  const target = to || href;

  let inner;
  if (target) {
    const internal = isInternalLink(target);
    inner = (
      <Button asChild {...rest}>
        {internal ? (
          <Link to={target}>{children}</Link>
        ) : (
          <a href={target} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        )}
      </Button>
    );
  } else {
    inner = (
      <Button type="button" onClick={onClick} {...rest}>
        {children}
      </Button>
    );
  }

  return <div className="mt-4">{inner}</div>;
}

EmptyState.Icon = Icon;
EmptyState.Title = Title;
EmptyState.Subtitle = Subtitle;
EmptyState.Action = Action;

export default EmptyState;
